import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React from "react";
import Landingpage from "../pages/LandingPage/landingPage";
import AboutPage from "../pages/AboutUsPage/aboutUsPage";
import ContactPage from "../pages/ContactPage/contactPage";
import NotFoundPage from "../pages/NotFoundPage/notFOund";
import CompanyPage from "../pages/Company/company";
import ResourcePage from "../pages/Resources/resourcesPage";
import SuccessStoriesPage from "../pages/SuccessStoriesPage/successStoriesPage";
import BlogPage from "../pages/BlogPage/blogPage";
import PlatformPage from "../pages/PlatformPage/platformPage";
import IndustryPage from "../pages/IndustryPage/industryPage";
import SolutionsPage from "../pages/Solutions/solutions";

export const MainRoutes = () => {
  return (
    <Router>
      <React.Fragment>
        <Routes>
          <Route path="/" element={<Landingpage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/careers" element={<CompanyPage />} />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/resources" element={<ResourcePage />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/platform" element={<PlatformPage />} />
          <Route path="/industries" element={<IndustryPage />} />
          <Route path="/success-stories" element={<SuccessStoriesPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </React.Fragment>
    </Router>
  );
};
